module.exports = __webpack_public_path__ + "static/img/main2-bg.1e61508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main2-bg.png
// module id = mzWw
// module chunks = 7